import { Button, ButtonGroup } from '@mui/material'
import type { CraftingInnerTabType } from '@/types'

interface Props {
  value: CraftingInnerTabType
  onChange: (next: CraftingInnerTabType) => void
}

export function CraftingRecipeModeTabBar({ value, onChange }: Props) {
  return (
    <ButtonGroup size="small" fullWidth>
      <Button
        variant={value === 'synthesis' ? 'contained' : 'outlined'}
        color={value === 'synthesis' ? 'warning' : 'inherit'}
        onClick={() => onChange('synthesis')}
        sx={{ fontSize: '0.75rem' }}
      >
        合成
      </Button>
      <Button
        variant={value === 'desynthesis' ? 'contained' : 'outlined'}
        color={value === 'desynthesis' ? 'warning' : 'inherit'}
        onClick={() => onChange('desynthesis')}
        sx={{ fontSize: '0.75rem' }}
      >
        分解
      </Button>
    </ButtonGroup>
  )
}
